import React from 'react';

import * as eventsApi from '../../../../../api/eventsApi';
import tagular from '../../../../../util/tagular';
import { getSortStrategy } from '../../../../../strategies/sortStrategies/sortStrategyFactory';

import Toggle from '../../../../toggle/toggle';
import DrawerSectionContainer from '../../../../shared/drawerSectionContainer/drawerSectionContainer';

import './guideSectionItem.scss';

class GuideSectionItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sectionExpanded: false,
            acceptedFilters: this.props.acceptedFilters,
            subsectionResults: []
        };

        this.handleSectionClick = this.handleSectionClick.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.filteredResults !== this.props.filteredResults) {
            const subsections = this.getSubsectionResults();

            this.setState({
                subsectionResults: subsections
            })

            if (subsections.length < 1 && !this.props.config.required) {
                this.setState({
                    sectionExpanded: false
                })
            }
        }
    }

    showSection() {
        return this.props.config.required || this.state.subsectionResults.length > 0;
    }

    getSubsectionResults() {
        const res = this.props.filteredResults.filter(filteredResult => {
            return this.state.acceptedFilters.includes(filteredResult.filters[0])
        });

        return res;
    }

    handleSectionClick(e, toggle) {
        toggle();

        const isCurrentlyExpanded = this.state.sectionExpanded;
        this.setState({ sectionExpanded: !isCurrentlyExpanded });

        if (!isCurrentlyExpanded) {
            eventsApi.expandClicked(this.props.assessmentInfo, { text: this.props.config.title });

            tagular.sendElementClickedEvent(e, { 
                position: 'Article Body', 
                location: 'CARDS',
                elementType: 'BUTTON',
                text: `${this.props.config.title}_${this.props.assessmentInfo.name}`,
                name: 'GUIDE',
                action: 'EXPAND',
                htmlId: `${this.props.promptId}`
            });
        }
    }

    render() {
        const {
            prompt,
            config,
            assessmentInfo
        } = this.props;

        let subsections = [];
        if (this.state.subsectionResults.length) {
            const sort = getSortStrategy(assessmentInfo.resultsConfig);
            const subsectionResults = sort(this.state.subsectionResults);

            subsections = subsectionResults.map((sub, idx) => (
                <div key={idx}>
                    <div className={`subsection-title  ${assessmentInfo.site}`}>{sub.title}</div>
                    <div className='subsection-description' dangerouslySetInnerHTML={{ __html: sub.briefDescription }} />
                </div>
            ))
        }

        return (
            <>
                {
                    this.showSection() ?

                    <Toggle expandAsDefault={false}>
                        {({ on, toggle }) => (
                            <div className='content-container border'>
                                <div className='guide-section'>
                                    <div className='guide-section-header'>
                                            <DrawerSectionContainer moduleExpanded={this.state.sectionExpanded} handleClick={(e) => this.handleSectionClick(e, toggle)} light={true} site={assessmentInfo.site}>
                                            <div className='copy-container'>
                                                <img className='guide-section-icon' src={config.imageUrl} alt="" />
                                                <h3 className={`guide-section-title ${assessmentInfo.site}`}>{config.title}</h3>
                                            </div>
                                        </DrawerSectionContainer>
                                    </div>
                                    
                                    {
                                        on &&
                                            <div id={prompt.id} className={`guide-section-content`}>
                                                <div className={`description ${assessmentInfo.site}`} dangerouslySetInnerHTML={{ __html: config.briefDescription }} />
                                                {subsections}
                                            </div>
                                        
                                    }
                                </div>
                            </div>
                        )}
                    </Toggle>

                    : null
                }
            </>
        );
    }
};

export default GuideSectionItem;